import ApiClient from './ApiClient';

class CrmSchedulerRulesAPI extends ApiClient {
  constructor() {
    super('crm_scheduler_rules', { accountScoped: true });
  }

  create(data) {
    return super.create({ crm_scheduler_rule: data });
  }

  update(id, data) {
    return super.update(id, { crm_scheduler_rule: data });
  }
}

export default new CrmSchedulerRulesAPI();
